'use client';

import React from 'react';
import clsx from 'clsx';
import styles from './HeroText.module.scss';
import Text from '@/components/Text/Text';

type HeroProps = {
  data: {
    title: string;
    description?: string;
  };
  className?: string;
};

const HeroText = ({ data, className = '' }: HeroProps) => (
  <section
    className={clsx(styles.hero, 'custom', className)}
  >
    <div className={clsx(styles.content, 'global-section')}>
      <div className={styles.textContainer}>
        <Text
          tag='h1'
          className={styles.title}
        >
          {data.title}
        </Text>
        {data?.description && (
          <p className={styles.description}>
            {data.description}
          </p>
        )}
      </div>
    </div>
  </section>
);

export default HeroText;
